import React from 'react';
import { FaBalanceScale, FaChalkboardTeacher, FaTools, FaUserGraduate } from 'react-icons/fa';
import { GiGraduateCap } from 'react-icons/gi';
import { MdHelpOutline, MdWork } from 'react-icons/md';
import { CategoriaEdital, formatarCategoria } from '../../../model/processo/Categoria';

interface CategoriaIconeProps {
    categoria: CategoriaEdital | string;
    className?: string;
    size?: number;
    showTooltip?: boolean;
}

const iconesPorCategoria = (size: number): Record<string, React.ReactElement> => ({
    [CategoriaEdital.ALUNO_TECNICO]: <FaTools size={size} />,
    [CategoriaEdital.ALUNO_GRADUACAO]: <FaUserGraduate size={size} />,
    [CategoriaEdital.ALUNO_POS]: <GiGraduateCap size={size} />,
    [CategoriaEdital.SERVIDOR]: <MdWork size={size} />,
    [CategoriaEdital.PROCURADOR]: <FaBalanceScale size={size} />,
    [CategoriaEdital.DOCENTE]: <FaChalkboardTeacher size={size} />
});

const CategoriaIcone: React.FC<CategoriaIconeProps> = ({
    categoria,
    className = '',
    size = 16,
    showTooltip = true
}) => {
    const mapa = iconesPorCategoria(size);
    const icone = mapa[categoria] || <MdHelpOutline size={size} />;
    const nomeFormatado = formatarCategoria(categoria as CategoriaEdital);

    const elemento = (
        <span className={className} style={{ marginRight: '6px' }}>
            {icone}
        </span>
    );

    if (!showTooltip) {
        return elemento;
    }

    return (
        <span title={`Categoria: ${nomeFormatado}`}>
            {elemento}
        </span>
    );
};

export default CategoriaIcone;

export const useCategoriaIcone = () => {
    const getCategoriaIcone = (categoria: CategoriaEdital | string, size: number = 16) => {
        const mapa = iconesPorCategoria(size);
        return mapa[categoria] || <MdHelpOutline size={size} />;
    };

    return { getCategoriaIcone };
};
